import { render } from "./RadioList.vue?vue&type=template&id=1fbea224"
import script from "./RadioList.vue?vue&type=script&lang=js"
export * from "./RadioList.vue?vue&type=script&lang=js"

import "./RadioList.vue?vue&type=style&index=0&id=1fbea224&lang=scss"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__